import { get } from '@/services/http';
import { SpreadsheetConnectedModel } from '@/models/spreadsheet_connected';
import List from './list';

// A "connected spreadsheet" is not its own entity: it is a ScheduleReports row
// carrying a non-null `type`. The retired /spreadsheet-clone funnel wrote
// `custom_spreadsheet_template`, and 19 of those are still ACTIVE across 15
// installed stores (checked 2026-09-10), which is why this page outlived the
// rest of the legacy family (AS-10798).
const LEGACY_SCHEDULE_TYPE = 'custom_spreadsheet_template';

export class SpreadsheetConnectedList extends List<SpreadsheetConnectedModel> {
  public async fetch() {
    // Previously `has_type=true`, i.e. ANY non-null type. That also matched the
    // `spreadsheet_template` rows the CURRENT Google Sheets feature creates for
    // each report sheet, so this page listed them indistinguishably from legacy
    // ones — behind a Disconnect button that hard-deletes the schedule. Asking
    // the backend for one type keeps the current feature's rows off the page
    // entirely rather than relying on the client to filter them out.
    const response: any = await get('/schedule', { type: LEGACY_SCHEDULE_TYPE });
    this.mapData(response.data);
  }

  public mapData(data: any = []) {
    this.items = [];
    for (const r of data) {
      // Belt and braces: the request above is already scoped, but a caller that
      // hands mapData a wider payload must not reintroduce the deletion hazard.
      if (r.type !== LEGACY_SCHEDULE_TYPE) {
        continue;
      }
      const spreadsheet = new SpreadsheetConnectedModel();
      spreadsheet.mapData(r);
      this.add(spreadsheet);
    }
  }
}
